
/**
 * package: com.inq.ui
 * class: Html
 * @constructor
 */
com.inq.ui.Literal = function (_id) {
    com.inq.ui.Container.call(this, _id)

    this.styles = {};

};


$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Literal, "com.inq.ui.Literal ");




/**
 * buildStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.Literal
 * @return {void}
 */

com.inq.ui.Literal.prototype.buildStyle = function () {
    var styleString = "";
    for (var prop in this.styles) {
        switch (prop) {
            case "id":
                this._div.setAttribute("id", this.styles[prop]);
                this._id = this.styles[prop];
                break;
            case "class":
                this._div.setAttribute("class", this.styles[prop]);
                break;
            case "src":
                this._div.setAttribute("src", this.styles[prop]);
                break;
            case "type":
                this._div.setAttribute("type", this.styles[prop]);
                break;
            case "tabindex":
                this._div.setAttribute("tabindex", this.styles[prop]);
                break;
            case "role":
                this._div.setAttribute("role", this.styles[prop]);
                break;
            case "innerHTML":
                this._div.innerHTML = this.styles[prop];
                break;
            case "innerText":
                this._div.innerText = this.styles[prop];

            default:
                styleString = styleString + prop + ":" + this.styles[prop] + ";"
        }






    }
    this._style = styleString;
}


/**
 * applyStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function applyStyle():Void
 * @override
 * @private
 * @this com.inq.ui.Literal
 * @return {void}
 */
com.inq.ui.Literal.prototype.applyStyle = function () {
    this.buildStyle();
    this._div.style.cssText = this._style;
};
/**@private @type {com.inq.ui.Literal} */
com.inq.ui.Literal.prototype.__class__ = com.inq.ui.Literal;

